import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "line-height"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#line-height" }),
  /*#__PURE__*/_createTextVNode(" Line Height ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" extends ")
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "fw-bold"
}, "Bootstrap Line Height Classes", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  to provide additonal line height options by overidding the line height SASS variable. ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".lh-{value}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's line height Where "),
  /*#__PURE__*/_createVNode("code", null, "value"),
  /*#__PURE__*/_createTextVNode(" is one of: ")
], -1)
const _hoisted_8 = { class: "pt-3 pb-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - for classes that set line height to ")
const _hoisted_10 = { class: "py-5" }
const _hoisted_11 = { class: "rounded border p-10" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Example text ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_15 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("b", null, _toDisplayString(_ctx.themeName), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6
    ]),
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lineHeightValues, (key, value, i) => {
        return (_openBlock(), _createBlock("li", {
          key: i,
          class: "py-2"
        }, [
          _createVNode("code", null, _toDisplayString(key), 1),
          _hoisted_9,
          _createVNode("code", null, _toDisplayString(value), 1)
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lineHeightValues, (key, value, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: [`lh-${key}`, "py-5"]
          }, [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createVNode("code", null, ".lh-" + _toDisplayString(key), 1)
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="lh-1">Example text for .lh-1</div>
        <div class="lh-sm">Example text for .lh-sm</div>
        <div class="lh-base">Example text for .lh-base</div>
        <div class="lh-lg">Example text for .lh-lg</div>
        <div class="lh-xl">Example text for .lh-xl</div>
        <div class="lh-xxl">Example text for .lh-xxl</div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}